import React, { useState, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux'

import { useAppSelector, useAppDispatch } from '../../store/hooks';

import {
  selectedDateRange,
  changeRangeDate,
  HomeState,
  addResult,
  changeComment,
  getCode
} from './HomePageActions';
import { Statistic, Icon, Card, Grid, Progress, Breadcrumb, Button, TextArea, Notification } from '@scuf/common';
import baseServices from "../../services/base.services";
import { Chart, Gauge, CircleGauge } from '@scuf/charts';
import styles from './DetailMetricPageStyle.css';
import Pareto from '../../components/Charts/Pareto/Pareto';
import UseDateRange from '../../customHook/useDateRange';

export interface PropsDetailDataList {
  title: any | null;
  value: any | null;
  icon: any | null;
}

function HomePage(propsPage: HomeState | null) {
  const selectedRange = useAppSelector(selectedDateRange);
  const dispatch = useAppDispatch();
  const [incrementAmount, setIncrementAmount] = useState('2');


  const addResults = (data: any) => {
    console.log(data);
    dispatch(addResult({comment: propsPage?.comment, code: propsPage?.code}));
  }

  
  useEffect(() => {
    dispatch(getCode({}))
  }, [dispatch])
  

  
  return (
    <Grid>
      <Grid.Row >
      
      { propsPage.result !== null ?
         propsPage.result ==  true ? 
         <Grid.Column width={12}>
         <div style={{padding:'20px', marginTop:'20px'}}>
          <Notification
          hasIcon={true}
          severity="success">
          Se ha enviado tu mensaje correctamente. Recibirá un correo electronico en cuanto su requerimiento sea analizado. 
          </Notification>
          <div style={{textAlign: 'right'}}>
          <Button type="secondary"
              size="small"
              style={{ marginTop: '10px', width:'100%'}}
              //disabled={load}
              onClick={()=> window.location.reload()}
              content="VOLVER"
              actionType="submit"
              //loading={load}
            />          
          </div>
          </div>
          </Grid.Column>
         : <div>No se enviado su comentario</div>
        :
        <Grid.Column width={12}>
        <div style={{ width: '100%', padding: '30px'}}>
          <h4 style={{ marginTop:'20px'}}>TU OPINIÓN ES IMPORTANTE</h4 >
          <div style={{display:'none'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <br></br>
            <TextArea label="" 
            width={{width:'100%'}}
            onChange={(v)=> dispatch(changeComment(v))}
            placeholder='Escribe tu comentario aqui...' 
            indicator="required"/>
            <br></br>
            <Button type="primary"
            
              style={{ marginTop: '10px' }}
              disabled={propsPage?.comment == null || propsPage?.comment == ''}
              onClick={addResults}
              content="ENVIAR"
              actionType="submit"
              //loading={load}
            />
          </div>
        </div>
        </Grid.Column>
      }
 
      </Grid.Row>

    </Grid>
  );
}

const mapState = (state: any) => (state.homePageReducer)

const mapDispatch = {
  //toggleOn: () => ({ type: 'TOGGLE_IS_ON' }),
}

const connector = connect(mapState, mapDispatch);
export default connector(HomePage)
